
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 4c0-.531.438-1 1-1h11c.531 0 1 .469 1 1v1H1V4zm0 3V6h13v.6c.358.183.693.404 1 .657V4c0-1.094-.906-2-2-2H2C.875 2 0 2.906 0 4v8c0 1.125.875 2 2 2h4.6a5.465 5.465 0 01-.393-1H2c-.563 0-1-.438-1-1V8h6.257c.314-.38.677-.716 1.08-1H1zm1.5 4c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5h-2z","fill":"#212121"}}),_c('path',{attrs:{"d":"M8 11.484c0 1.282.656 2.407 1.75 3.032 1.063.656 2.406.656 3.5 0A3.505 3.505 0 0015 11.484c0-1.25-.688-2.375-1.75-3-1.094-.656-2.438-.656-3.5 0a3.428 3.428 0 00-1.75 3zm8 0a4.54 4.54 0 01-2.25 3.907 4.458 4.458 0 01-4.5 0A4.475 4.475 0 017 11.484c0-1.593.844-3.062 2.25-3.875a4.458 4.458 0 014.5 0c1.375.813 2.25 2.282 2.25 3.875zm-4-2v1.5h1.5c.25 0 .5.25.5.5 0 .282-.25.5-.5.5H12v1.5c0 .282-.25.5-.5.5a.494.494 0 01-.5-.5v-1.5H9.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5H11v-1.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5z","fill":"#212121"}})])
          )
        }
      }
    